import { useState } from 'react';
export function useAsyncDebounce(func, delay = 1000) {
    const [timer, setTimer] = useState();
    const debouncedFunction = ((...args) => {
        return new Promise((resolve, reject) => {
            if (timer) {
                clearTimeout(timer);
            }
            const newTimer = setTimeout(async () => {
                try {
                    const result = await func(...args);
                    resolve(result);
                }
                catch (error) {
                    reject(error);
                }
            }, delay);
            setTimer(newTimer);
        });
    });
    return debouncedFunction;
}
